import api from './api';

// Gallery Folder APIs
export const getGalleryItems = async () => {
  const response = await api.get('/gallery');
  return response.data;
};

export const getGalleryItemById = async (id) => {
  const response = await api.get(`/gallery/${id}`);
  return response.data;
};

export const createGalleryItem = async (formData) => {
  const response = await api.post('/gallery', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const updateGalleryItem = async (id, formData) => {
  const response = await api.put(`/gallery/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const deleteGalleryItem = async (id) => {
  const response = await api.delete(`/gallery/${id}`);
  return response.data;
};

// Gallery Image Batch APIs
export const addImagesToGalleryFolder = async (folderId, formData) => {
  const response = await api.post(`/gallery/${folderId}/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const updateGalleryImageOrder = async (orderData) => {
  const response = await api.put('/gallery/images/order', orderData);
  return response.data;
};

export const bulkDeleteGalleryImages = async (data) => {
  const response = await api.delete('/gallery/images/delete/bulk', {
    data: data
  });
  return response.data;
};
